interface TopicItem {
  name: string;
  hot: string;
  color: string;
}

const topics: TopicItem[] = [
  { name: '鬼灭之刃', hot: '986万', color: 'bg-primary-100 text-primary-700' },
  { name: '芙莉莲', hot: '872万', color: 'bg-accent-100 text-accent-800' },
  { name: '咒术回战', hot: '815万', color: 'bg-secondary-100 text-secondary-700' },
  { name: '我推的孩子', hot: '753万', color: 'bg-primary-100 text-primary-700' },
  { name: '药屋少女', hot: '691万', color: 'bg-accent-100 text-accent-800' },
  { name: '间谍过家家', hot: '567万', color: 'bg-secondary-100 text-secondary-700' },
  { name: '一拳超人', hot: '489万', color: 'bg-primary-100 text-primary-700' },
  { name: '迷宫饭', hot: '421万', color: 'bg-accent-100 text-accent-800' },
  { name: '防风铃', hot: '356万', color: 'bg-secondary-100 text-secondary-700' },
  { name: '怪兽8号', hot: '298万', color: 'bg-primary-100 text-primary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">当前91樱花社区讨论度最高的话题标签与热度</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item, idx) => (
            <span
              key={idx}
              className={`inline-flex items-center gap-2 px-5 py-3 rounded-full ${item.color} text-sm font-medium cursor-pointer transition-all duration-200 hover:scale-105 whitespace-nowrap`}
            >
              <span>{item.name}</span>
              <span className="text-xs opacity-70">{item.hot}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}